function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.868 20.063C.868 9.49 9.444.915 20.016.915c10.598 0 19.148 8.575 19.148 19.148 0 10.598-8.55 19.148-19.148 19.148C9.444 39.21.868 30.66.868 20.065z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 21v12h4V21zm-8.232 3.876V33h4.327v-8.124zM26 23v10h3.95V23z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.52 20.496h4.96v13.012h-4.96zm-7.92 4.1h4.914v8.91H9.6zm15.922-2.056h4.947v10.968h-4.95z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.163 24.67l1.382 4.645-1.804 1.78-4.606-1.37-.05-.064zM6.346 17.708l-.78-.794c-.743-.806-.782-2.112-.257-2.688.88-.87 1.777-1.74 2.66-2.624.218-.217.55-.332.92-.345.63-.026 1.346.217 1.756.653l.78.793z",
  fillRule: "evenodd",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.535 20.067C.535 9.305 9.265.575 20.025.575c10.79 0 19.493 8.73 19.493 19.492 0 10.788-8.704 19.49-19.492 19.49-10.762 0-19.49-8.702-19.49-19.49",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.79999989,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.503 4.14L27 7l-4.497 2.95V8.5h-3.81l-.067.168c-.502.75-1.346 1.26-2.304 1.26-1.505 0-2.76-1.284-2.76-2.882 0-1.574 1.255-2.857 2.76-2.857.958 0 1.802.507 2.304 1.258l.068.145h3.81z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.503 4.04l4.956 2.956-4.957 2.955V8.475h-3.81l-.067.172c-.502.763-1.346 1.28-2.304 1.28-1.505 0-2.76-1.305-2.76-2.93 0-1.6 1.255-2.907 2.76-2.907.958 0 1.802.517 2.304 1.28l.068.148h3.81z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000025,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.552 13.032l4.966 3.002-4.966 3.003v-1.5H18.96l-.097.168c-.525.775-1.385 1.307-2.387 1.307-1.6 0-2.913-1.33-2.913-2.978 0-1.622 1.313-2.953 2.913-2.953 1.002 0 1.862.533 2.387 1.308l.096.145h7.592z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.552 13.032l4.966 3.002-4.966 3.003v-1.5H18.96l-.097.168c-.525.775-1.385 1.307-2.387 1.307-1.6 0-2.913-1.33-2.913-2.978 0-1.622 1.313-2.953 2.913-2.953 1.002 0 1.862.533 2.387 1.308l.096.145h7.592z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000013,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M25.545 29.315l.333 1.127c.205.806-.243 1.24-1.01.985l-1.127-.332zm-6.463.345L6.346 16.71l5.08-5.005L24.164 24.67z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M25.545 29.315l.333 1.127c.205.806-.243 1.24-1.01.985l-1.127-.332"
}), React.createElement("path", {
  d: "M24.163 24.67l1.382 4.645-1.804 1.78-4.606-1.37-.05-.064M6.346 16.71l-.78-.794c-.743-.806-.782-2.112-.257-2.688.88-.87 1.777-1.74 2.66-2.624.218-.217.55-.332.92-.345.63-.026 1.346.217 1.756.653l.78.793"
}), React.createElement("path", {
  d: "M19.082 29.66L6.346 16.71l5.08-5.005L24.164 24.67z"
})));

var SvgInsightSubmenuEditrules = function SvgInsightSubmenuEditrules(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsightSubmenuEditrules, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Insight-submenu-editrules.94b239e2.svg";
export { ForwardRef as ReactComponent };